export const NOTES_CARET_FADE_MS = 3000;
export const NOTES_PRESENCE_VIEW_TTL_MS = 60_000;

export const NOTES_PRESENCE_COLORS = [
  { caret: "#0072a2", bg: "rgba(0, 114, 162, 0.15)" },
  { caret: "#8b5cf6", bg: "rgba(139, 92, 246, 0.15)" },
  { caret: "#10b981", bg: "rgba(16, 185, 129, 0.15)" },
  { caret: "#f59e0b", bg: "rgba(245, 158, 11, 0.15)" },
  { caret: "#ec4899", bg: "rgba(236, 72, 153, 0.15)" },
  { caret: "#06b6d4", bg: "rgba(6, 182, 212, 0.15)" }
] as const;

export type NotesPresenceColor = (typeof NOTES_PRESENCE_COLORS)[number];

export type NotesPeerPresence = {
  identity: string;
  name: string;
  color: NotesPresenceColor;
  selectionStart: number;
  selectionEnd: number;
  isTyping: boolean;
  isViewingNotes: boolean;
  updatedAt: number;
};

export function colorForNotesIdentity(identity: string): NotesPresenceColor {
  let hash = 0;
  for (let i = 0; i < identity.length; i += 1) {
    hash = (hash + identity.charCodeAt(i)) | 0;
  }
  return NOTES_PRESENCE_COLORS[Math.abs(hash) % NOTES_PRESENCE_COLORS.length];
}

export function initialsFromDisplayName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
}

export function isCaretVisible(peer: NotesPeerPresence, now = Date.now()): boolean {
  return now - peer.updatedAt < NOTES_CARET_FADE_MS || peer.isTyping;
}

export function isInNotesPresenceStack(peer: NotesPeerPresence, now = Date.now()): boolean {
  if (!peer.isViewingNotes) return false;
  return now - peer.updatedAt < NOTES_PRESENCE_VIEW_TTL_MS;
}
